import React from 'react';
import { navigate } from 'gatsby';
// import { isLoggedIn } from "../services/auth"

// checking if the user is logged in based on the expiration of their token

function brandingInProgress() {
    if (
        typeof window !== 'undefined' &&
        localStorage.getItem('brandedProgress')
    ) {
        return true;
    } else {
        return false;
    }
}

const BrandedRoute = ({ component: Component, location, ...rest }) => {
    if (!brandingInProgress() && location.pathname !== `/branded`) {
        navigate('/branded');
        return null;
    } else {
        return (
            <>
                <Component {...rest} />
            </>
        );
    }
};
export default BrandedRoute;
